import { GET_DRIVER_LIST, GET_ADDDRIVER, GET_UPDATEDRIVER, GET_TICKETDRIVER, GET_MATRIXDRIVER, GET_MOREDRIVER} from "resources/actionTypes";

const initialState = {
  userDriver: [],
  loading: false,
  error: null,
};

const initialStateAdd = {
  userAddDriver: [],
  loading: false,
  error: null,
}

const initialStateUpdate = {
  userUpdateDriver: [],
  loading: false,
  error: null,
}

const initialStateMatrix = {
  userMatrixDriver: [],
  loading: false,
  error: null,
}


const initialStateMore = {
  userMoreDriver: [],
  loading: false,
  error: null,
}


const initialStateTicket = {
  userTicketDriver: [],
  loading: false,
  error: null,
}

export function userDriver(state =
  initialState, action) {
  switch (action.type) {
    case GET_DRIVER_LIST.GET_DRIVER_LIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_DRIVER_LIST.GET_DRIVER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        userDriver: action.userDriver
      };
    case GET_DRIVER_LIST.GET_DRIVER_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}


export function userAddDriver(state = initialStateAdd, action) {
  switch (action.type) {
    case GET_ADDDRIVER.GET_ADDDRIVER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDDRIVER.GET_ADDDRIVER_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddDriver: action.userAddDriver,
      };
    case GET_ADDDRIVER.GET_ADDDRIVER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateDriver(state = initialStateUpdate, action) {
  switch (action.type) {
    case GET_UPDATEDRIVER.GET_UPDATEDRIVER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATEDRIVER.GET_UPDATEDRIVER_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateDriver: action.userUpdateDriver,
      };
    case GET_UPDATEDRIVER.GET_UPDATEDRIVER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userMatrixDriver(state =
  initialStateMatrix, action) {
  switch (action.type) {
    case GET_MATRIXDRIVER.GET_MATRIXDRIVER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_MATRIXDRIVER.GET_MATRIXDRIVER_SUCCESS:
      return {
        ...state,
        loading: false,
        userMatrixDriver: action.userMatrixDriver
      };
    case GET_MATRIXDRIVER.GET_MATRIXDRIVER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userTicketDriver(state =
  initialStateTicket, action) {
  switch (action.type) {
    case GET_TICKETDRIVER.GET_TICKETDRIVER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_TICKETDRIVER.GET_TICKETDRIVER_SUCCESS:
      return {
        ...state,
        loading: false,
        userTicketDriver: action.userTicketDriver
      };
    case GET_TICKETDRIVER.GET_TICKETDRIVER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userMoreDriver(state =
  initialStateMore, action) {
  switch (action.type) {
    case GET_MOREDRIVER.GET_MOREDRIVER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_MOREDRIVER.GET_MOREDRIVER_SUCCESS:
      return {
        ...state,
        loading: false,
        userMoreDriver: action.userMoreDriver
      };
    case GET_MOREDRIVER.GET_MOREDRIVER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
